import { Nav } from "react-bootstrap";
import "./Navbar.css";
import logo from "../../assets/img/logo.png";
import { useEffect, useState } from "react";
import { openWhatsApp } from "../../utils/whatsapp";
import { ReactComponent as Logo } from "../../assets/img/logo.svg";
import { ReactComponent as Icone } from "../../assets/img/icone-claro.svg";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMenu, setIsMenu] = useState(false);
  const [isActiveMenu, setIsActiveMenu] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    return () => {
      document.body.classList.remove("mobile-nav-active");
    };
  }, []);

  const onClickMenu = () => {
    setIsMenu((prev) => {
      const newState = !prev;
      if (newState) {
        document.body.classList.add("mobile-nav-active");
      } else {
        document.body.classList.remove("mobile-nav-active");
      }
      return newState;
    });
  };

  const onClickLinkMenu = (menu) => {
    setIsActiveMenu(menu);
    setIsMenu(false);
    document.body.classList.remove("mobile-nav-active");
  };

  return (
    <>
      <header
        id="header"
        className={`${
          scrolled ? "header scrolled" : "header"
        } d-flex align-items-center sticky-top `}
      >
        <div className="container-fluid container-xl position-relative d-flex align-items-center">
          <a href="#home" className="logo d-flex align-items-center me-auto">
            <img className="logo" src={logo} alt="Logo Pontes Tecnologia" />
          </a>

          <Nav id="navmenu" className="navmenu">
            <ul>
              <li>
                <a
                  href="#home"
                  className={isActiveMenu === "home" ? "active" : null}
                  onClick={() => onClickLinkMenu("home")}
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  className={isActiveMenu === "about" ? "active" : null}
                  onClick={() => onClickLinkMenu("about")}
                >
                  Sobre nós
                </a>
              </li>
              <li>
                <a
                  href="#solutions"
                  className={isActiveMenu === "solutions" ? "active" : null}
                  onClick={() => onClickLinkMenu("solutions")}
                >
                  Soluções
                </a>
              </li>
              <li>
                <a
                  href="#budget"
                  className={isActiveMenu === "budget" ? "active" : null}
                  onClick={() => onClickLinkMenu("budget")}
                >
                  Orçamento
                </a>
              </li>
            </ul>
            <i
              className={`mobile-nav-toggle d-xl-none bi ${
                isMenu ? "bi-x" : "bi-list"
              }`}
              onClick={onClickMenu}
            />
          </Nav>

          <a className="btn-getstarted" onClick={() => openWhatsApp()}>
            Contato
          </a>
        </div>
      </header>
    </>
  );
}

export default Navbar;
